/* Materiais do modo demonstração (fator em kgCO₂e por unidade, como em backend.lista_fatores_bens_servicos). */

import type { ItemLista } from '../tipos/api';

/** Material com fator (kgCO₂e por unidade) e densidade (kg/m³), como em backend.lista_fatores_bens_servicos. */
export interface MaterialDemo extends ItemLista {
  id: number;
  unidade: string;
  fe: number;
  densidade?: number;
}

export const MATERIAIS: MaterialDemo[] = [
  { id: 8, nome: 'aço', unidade: 't', fe: 1900 },
  { id: 9, nome: 'areia', unidade: 't', fe: 2.39 },
  { id: 18, nome: 'brita', unidade: 't', fe: 4.27 },
  { id: 24, nome: 'cimento cp i', unidade: 't', fe: 775.76 },
  { id: 30, nome: 'concreto 35 mpa', unidade: 'm3', fe: 262.01, densidade: 2400 },
  { id: 60, nome: 'arame de aço', unidade: 't', fe: 994 },
  { id: 102, nome: 'bloco cerâmico - ved15 (14x19x29) cm', unidade: 't', fe: 150.56 },
];
